/* Bedfellow scroll reveals — progressive enhancement */
(function(){
  if(window.__bedfellowScrollMotionLoaded)return;
  window.__bedfellowScrollMotionLoaded=true;
  function init(scope){
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches||!('IntersectionObserver' in window))return;
    var selectors=[
      '#bf-store .bf-copy','#bf-store .bf-art','#bf-store .bf-center',
      '#bf-store .bf-card','#bf-store .bf-colour-item','#bf-store .bf-feature-art',
      '#bf-store .bf-feature-copy','#bf-store .bf-faq details','#bf-store .bf-final',
      '#bf-product-story .bps-center','#bf-product-story .bps-card',
      '#bf-product-story .bps-feature','#bf-product-story .bps-faq details',
      '#bf-product-story .bps-bottom','#bf-product-story #bf-product-3d-stage',
      '#bf-extra-product .bfx-figure','#bf-extra-product .bfx-illustration-intro',
      '#bf-extra-product .bfx-split','#bf-extra-product .bfx-visual-heading',
      '.bfp-page .bfp-hero','.bfp-page .bfp-card','.bfp-page .bfp-heading',
      '.bfp-page .bfp-faqs details','.bfp-page .bfp-note'
    ];
    var els=Array.prototype.slice.call((scope||document).querySelectorAll(selectors.join(',')));
    if(!els.length)return;
    var observer=new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(entry.isIntersecting){entry.target.classList.add('bf-scroll-in');observer.unobserve(entry.target)}
      });
    },{threshold:.06,rootMargin:'0px 0px -22px 0px'});
    els.forEach(function(el){
      if(el.classList.contains('bf-scroll-reveal'))return;
      var siblings=el.parentElement?Array.prototype.slice.call(el.parentElement.children):[];
      var index=siblings.filter(function(n){return n.matches('.bf-card,.bf-colour-item,.bps-card,.bfp-card,.bfx-figure')}).indexOf(el);
      if(index>=0)el.style.setProperty('--bf-reveal-delay',Math.min(index,4)*90+'ms');
      el.classList.add('bf-scroll-reveal');
      observer.observe(el);
    });
    document.documentElement.classList.add('bf-motion-on');
    window.setTimeout(function(){els.forEach(function(el){el.classList.add('bf-scroll-in')})},7000);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document)},{once:true});else init(document);
  document.addEventListener('shopify:section:load',function(event){init(event.target)});
})();